export default {
      id: "cube-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.b61b1948.svg#cube",
      toString: function () {
        return this.url;
      }
    }